import React from 'react';
import studentAssignmentsStore from './StudentAssignments.store';
import {RANGES} from 'generic/SelectableDateRange/shared';
import studentEmptyState from './students-empty-state.svg';
import './no-assignments-found-placeholder.scss';

export default class NoAssignmentsFoundPlaceholder extends React.PureComponent {
  render() {
    const selectedDateRange = studentAssignmentsStore.getDueDateRangeId();
    if (!selectedDateRange) {
      return null;
    }
    const bodyText =
      studentAssignmentsStore.getDueDateRangeId() === RANGES.ALL_TIME
        ? 'No assignments found'
        : `No assignments due ${selectedDateRange.toLowerCase()}`;
    return (
      <div className='no-assignments-found-placeholder'>
        <img
          alt=''
          className='no-assignments-found-placeholder__image'
          role='presentation'
          src={studentEmptyState}
        />
        <h2 className='no-assignments-found-placeholder__heading'>Whew, no work to do!</h2>
        <p className='no-assignments-found-placeholder__body'>{bodyText}</p>
      </div>
    );
  }
}
